import widgetWrapper from './../infrastructure/WidgetWrapper'
import OperationWidget from './../components/OperationWidget'

export default widgetWrapper(OperationWidget)



// WEBPACK FOOTER //
// ./src/containers/OperationWidgetContainer.js